import { render, staticRenderFns } from "./RecommendationModal.vue?vue&type=template&id=034942ef&"
import script from "./RecommendationModal.vue?vue&type=script&lang=js&"
export * from "./RecommendationModal.vue?vue&type=script&lang=js&"
import style0 from "./RecommendationModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports